export const constant = (x) => () => x
